<template>
  <div class="Hot">
    <mu-tabs :value.sync="active"
             @change="tabChange"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>热销</mu-tab>
      <mu-tab>锦医未</mu-tab>
      <mu-tab>整合式</mu-tab>
      <mu-tab>体检</mu-tab>
      <mu-tab>胃肠道</mu-tab>
    </mu-tabs>
    <div class="main">
      <ul class="icon" v-if="active === 0" >
        <li v-for="item in icon_list" :key="item.id" @click="link_list(item)" >
          <img :src="item.url" alt="">
          <p>{{ item.name }}</p>
        </li>
      </ul>

      <template v-if="list.length != 0">
        <ul class="list_ul">
          <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
            <li v-for="item in list" :key="item.id" @click="link(item)" >
              <img :src="item.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ item.productName }}</h2>
                <p class="list_item_p1">{{ item.subhead }}</p>
                <p class="list_item_p2">¥ {{ item.price }}</p>
              </div>
            </li>
          </mu-load-more>
        </ul>
      </template>

      <template v-else>
        <NoList>
          <template #text>
            <p>暂无数据</p>
          </template>
        </NoList>
      </template>


    </div>

  </div>
</template>

<script>
import icon1 from "../../assets/Hot/icon1.png";
import icon2 from "../../assets/Hot/icon2.png";
import icon3 from "../../assets/Hot/icon3.png";
import icon4 from "../../assets/Hot/icon4.png";
import icon5 from "../../assets/Hot/icon5.png";
import icon6 from "../../assets/Hot/icon6.png";
import icon7 from "../../assets/Hot/icon7.png";
import icon8 from "../../assets/Hot/icon8.png";

export default {
  name: "Hot",
  data() {
    return{
      active: 0,
      loadall: false,
      loading: false,
      icon_list: [
        {
          id: 0,
          url: icon1,
          name: "中青年",
          data: "fitAge",
          state: "0",
        },
        {
          id: 1,
          url: icon2,
          name: "中老年",
          data: "fitAge",
          state: "1",
        },
        {
          id: 2,
          url: icon3,
          name: "男士套餐",
          data: "fitGender",
          state: "1",
        },
        {
          id: 3,
          url: icon4,
          name: "女士套餐",
          data: "fitGender",
          state: "0",
        },
        {
          id: 4,
          url: icon5,
          name: "入职体检",
          data: "productFeature",
          state: "0",
        },
        {
          id: 5,
          url: icon6,
          name: "驾驶员体检",
          data: "productFeature",
          state: "1",
        },
        {
          id: 6,
          url: icon7,
          name: "尊享高端",
          data: "productFeature",
          state: "2",
        },
        {
          id: 7,
          url: icon8,
          name: "胃肠道筛查",
          data: "productFeature",
          state: "3",
        },
      ],
      json_list: {
        pageNum: 1,
        pageSize: 10,
        productCategory: null,
        isHot: true,
      },
      list: []
    }
  },
  created() {
    this.get_list(this.json_list);
  },
  mounted() {

  },
  methods: {
    get_list(y) {
      this.$get("product",y)
        .then(res => {
          if(res) {
            console.log(res.data.pageInfo);
            this.loadall= !res.data.pageInfo.hasNextPage;
            this.loading= false;

            res.data.pageInfo.list.forEach((item) => {
              this.list.push(item);
            })

          }
        })
    },
    link(e) {
      this.$router.push({
        path: "/Deta",
        query: {
          id: e.productId,
          thumbnail: e.thumbnail,
          productName: e.productName,
        }
      })
    },
    link_list(e) {

      let obj= {};
      obj["data"]= e.data;
      obj["state"]= e.state;
      obj["name"]= e.name;

      this.$router.push({
        path: "/list",
        query: {
          screen: JSON.stringify(obj)
        }
      })
    },
    load() {
      console.log("loading");
      this.loading= true;
      this.json_list.pageNum= this.json_list.pageNum + 1;
      this.get_list(this.json_list);
    },
    tabChange(e) {

      this.list= [];
      this.json_list.pageNum= 1;
      this.json_list.pageSize= 10;

      if(e === 0) {
        this.json_list.productCategory= null;
        this.json_list.isHot= true;

      }else if(e === 1) {
        this.json_list.productCategory= 3;
        this.json_list.isHot= true;

      }else if(e === 2) {
        this.json_list.productCategory= 2;
        this.json_list.isHot= true;

      }else if(e === 3) {
        this.json_list.productCategory= 0;
        this.json_list.isHot= true;

      }else if(e === 4) {
        this.json_list.productCategory= 1;
        this.json_list.isHot= true;
      }

      this.get_list(this.json_list);

    }
  }
}
</script>

<style lang="less" scoped>
  .list_ul{
    height: calc( 100% - 48px );
  }
  @import "../../style/Nav/Hot.less";
  @import "../../style/Make/MakeListDeta/List";
</style>
